import z from "zod";
import { LondonCareRecordConfigIdSchema } from "./londonCareRecord/londonCareRecordInstance.js";
import { TrustIdSchema } from "./trust.js";
export const TrustOidSchema = z
    .object({
    trustId: TrustIdSchema,
    oid: z.string().min(1).max(255),
    lcrInstanceId: LondonCareRecordConfigIdSchema.nullable(),
})
    .brand();
//# sourceMappingURL=trustOid.js.map